module.exports = __webpack_public_path__ + "0.f9a715d167fe2d23b5bf.worker.js"